import { DataFrame } from "../dataFrame";

export const copy = df => DataFrame(df);